var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop-container"},[_c('span',{ref:"message-container"},[_c('p',[_vm._v("Please view experience on a mobile device.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }